import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";

import { useRecruiterBookingFlowContext } from "../../hooks/useRecruiterBookingFlowContext";

export function RecruiterScreeningCallMeNowContactActions() {
  const bookingFlowState = useRecruiterBookingFlowContext();

  const onConfirmCallSelected = async () => {
    void bookingFlowState.contactDetailsForm.handleSubmit(bookingFlowState.onCallMeNow)();
  };

  const onBackSelected = () => {
    bookingFlowState.reset();
  };

  return (
    <Stack spacing={4} width="100%">
      <Button
        fullWidth
        variant="contained"
        size="large"
        disabled={bookingFlowState.isLoading}
        onClick={onConfirmCallSelected}
      >
        Confirm call
      </Button>
      <Button
        fullWidth
        variant="outlined"
        size="large"
        disabled={bookingFlowState.isLoading}
        onClick={onBackSelected}
      >
        Back
      </Button>
    </Stack>
  );
}
